module.exports = __webpack_public_path__ + "img/icon_home_ai_icon_15.30abc62b.png";